export default __webpack_public_path__ + "static/media/python.1cdaefb5.pdf";